import { SET_GLOBAL_CONFIGURATION } from "./actions.types";

export const updateGlobalConfigurationsAction = (globalConfigurations: any) => {
  return {
    type: SET_GLOBAL_CONFIGURATION,
    globalConfigurations,
  };
};
